import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import { NitroGrid } from "nitro-components";
import CardWithHeader from "./CardWithHeader";
import ReportDetailedView from "./ReportDetailedView";
import Breakpoint from "../../../utils/breakpoints";

const Container = styled.div`
	display: flex;
	flex-direction: row;
    flex-wrap: wrap;
`;

const GridContainer = styled.div``;

class ReportContainer extends Component {
	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	componentWillMount() {}

	componentDidMount() {}

	componentWillReceiveProps(nextProps) {}

	shouldComponentUpdate(nextProps, nextState) {
		return this.props.leaseId !== nextProps.leaseId;
	}

	componentWillUpdate(nextProps, nextState) {}

	componentWillUnmount() {}

	generatePanel = () => {};

	onClick = id => {
		this.props.onClickNavigate(id);
	};

	render() {
		const {
			reports,
			countryCode,
			companyCode,
			driverId,
			leaseId,
			type
		} = this.props;
		console.log(reports);
		let reportItems = reports.map((item, index) => {
			const obj = item.Title === "Odometer" ||
				item.Title === "Next scheduled service"
				? {}
				: {
						label: "SEE REPORT",
						action: () => this.onClick(item.Route)
					};
			const contentDisplayType = item.Title === "Next scheduled service"
				? "block"
				: "flex";
			const contentPadding = item.Title === "Next scheduled service"
				? "50"
				: "0";

			return (
				<CardWithHeader
					key={`report-card-${index}`}
					grid={2}
					panelHeight="300px"
					transition
					transitionDelay={100 * index}
					transitionDuration={800}
					headerLeft={item.Title}
					headerRight={obj}
					noPadding
					fixedWidth="500px"
					contentDisplayType={contentDisplayType}
					contentPadding={contentPadding}
				>

					<GridContainer>
						{/**Condition To be removed - Added to prevent telematics from loading**/}

						<ReportDetailedView
							reportTitle={item.Title}
							reportUrl={item.Url}
							reportId={item.Id}
							companyCode={companyCode}
							countryCode={countryCode}
							driverId={driverId}
							fetchReportDetail={this.props.fetchReportDetail}
							leaseId={leaseId}
							type={type}
						/>

					</GridContainer>
				</CardWithHeader>
			);
		});
		/*let reportItemsMobile = reports.map((item, index) => {
			const obj = item.Title === "Odometer" ||
				item.Title === "Next scheduled service"
				? {}
				: {
						label: "SEE REPORT",
						action: () => this.onClick(item.Route)
					};

			let displayLastGrid = item.Title === "Odometer"
				? true
				: index !== reports.length - 1 ? true : false;

			const contentDisplayType = item.Title === "Next scheduled service"
				? "block"
				: "flex";
			const contentPadding = item.Title === "Next scheduled service"
				? "50"
				: "0";
			return (
				<CardWithHeader
					key={`report-card-${index}`}
					grid={1}
					panelHeight="300px"
					transition
					transitionDelay={100 * index}
					transitionDuration={800}
					headerLeft={item.Title}
					headerRight={obj}
					noPadding
					fixedWidth="500px"
					contentDisplayType={contentDisplayType}
					contentPadding={contentPadding}
				>
					<GridContainer>
						
							<ReportDetailedView
								reportTitle={item.Title}
								reportUrl={item.Url}
								reportId={item.Id}
								companyCode={companyCode}
								countryCode={countryCode}
								driverId={driverId}
								fetchReportDetail={this.props.fetchReportDetail}
							/>}

					</GridContainer>
				</CardWithHeader>
			);
		});*/
		return (
			<div>
				<Breakpoint name="desktop">
					<Container>
						{reportItems}{" "}
					</Container>
				</Breakpoint>
				{/*<Breakpoint name="mobileTablet">
					<Container>{reportItemsMobile}</Container>
				</Breakpoint>*/}
			</div>
		);
	}
}

ReportContainer.propTypes = {
	reports: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	fetchReportDetail: PropTypes.func,
	companyCode: PropTypes.string,
	countryCode: PropTypes.string,
	driverId: PropTypes.string,
	leaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	type: PropTypes.string
};

ReportContainer.defaultProps = {
	// defaultProp: ''
};

export default ReportContainer;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ReportContainer.js